<!--招行缴纳押金-->
<template>
  <div class="pay-deposit">
    <section class="pay-progress page-content">
      <p class="title">操作步骤</p>
      <div class="progress">
        <p class="progress-title finished">
          <i class="progress-icon"></i>
          <span>绑定成功</span>
        </p>
        <div class="progress-content has-line">
          <div class="info">
            <p>已经成功绑定一网通免密支付</p>
          </div>
        </div>
        <p class="progress-title processing">
          <i class="progress-icon"></i>
          <span>缴纳押金</span>
        </p>
        <div class="progress-content">
          <div class="info">
            <p>请缴纳150元押金，请在90天内完成设备激活，押金将自动原路返还</p>
          </div>
        </div>
      </div>
      <div class="tip-content" color-primary>
        <p class="tip-title">特别提醒</p>
        <p class="tip">在您使用本服务<span color-red-tip>3年内</span>，必须绑定一网通免密支付。若您单方面解绑，需要缴纳<span color-red-tip>180元违约金</span>。您应该确保绑定的一网通免密支付内有足额款项扣款。如您账户状态异常或未有足够的款项，不能扣划ETC费用，您将会被列入高速连网黑名单，并影响个人征信。</p>
      </div>
    </section>
    <section class="deposit-bottom">
      <form id="payForm" method="post" :action="postData.payment_info.url" v-if="postData.payment_info.url">
        <input style="display: none" type="text" name="charset" value="UTF-8">
        <input style="display: none" type="text" name="jsonRequestData" v-model="postData.payment_info.queryData">
      </form>
      <button cool-btn @click="payDeposit">缴纳150元押金</button>
      <button class="cancel-btn" @click="m_goPages('cancelOrder')">取消申办</button>
    </section>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
// api
import ApplyApi from '@/api/apply.api'
// store
import {mapState} from 'vuex'

export default {
  name: 'payDeposit',
  mixins: [FunMixin],
  components: {},
  data() {
    return {
      postData: {payment_info: ''}
    }
  },
  computed: {
    ...mapState([
      'currentOrder'
    ])
  },
  methods: {
    async payDeposit() {
      const res = await ApplyApi.getPaymentInfo({order_sn: this.currentOrder.order_sn})
      if (res.payment_info && res.payment_info.url) {
        // location.href = res.payment_info.url + '&jsonRequestData=' + res.payment_info.queryData
        this.postData = res
        setTimeout(() => {
          document.getElementById('payForm').submit()
        })
      }
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";
.pay-deposit{
  @include routeViewMinH(210px);
  .pay-progress{
    padding: 50px 40px;
    .title{
      font-size: 36px;
      line-height: 50px;
      height: 50px;
      padding-left: 24px;
      @include title-before(4px, 40px);
    }
    .progress{
      padding: 0 30px;
      .progress-title{
        font-size: 30px;
        height: 42px;
        line-height: 42px;
        font-weight: bold;
        //@extend %flex-align-center;
        padding-left: 42px;
        margin-top: 30px;
        margin-bottom: 10px;
        position: relative;
        .progress-icon{
          position: absolute;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          border: 10px solid #FFFFFF;
          left: 0;
          top: 50%;
          transform: translateY(-50%) translateX(-50%);
          z-index: 10;
          background-color: #fff;
          &.iconfont{
            width: inherit;
            height: inherit;
          }
        }
        &.processing{
          .progress-icon {
            background-color: $primary-color;
          }
        }
        &.finished{
          color: #333333;
          .progress-icon {
            background-color: #cccccc;
          }
        }
      }
      .progress-content{
        position: relative;
        padding-bottom: 20px;
        @extend %flex-space-between;
        .info{
          padding-left: 42px;
          font-size: 24px;
          color: #666666;
          line-height: 40px;
          p {
            /*margin-top: 10px;*/
            .copy-btn {
              margin-left: 20px;
            }
          }
        }
      }
      .has-line{
        position: relative;
        &:before{
          content: '';
          position: absolute;
          width: 1px;
          height: calc(100% + 80px);
          left: 0;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
          z-index: 9;
          background-color: #cccccc;
        }
      }
    }
    .tip-content{
      background-color: #F2F9F2;;
      border-radius: 10px;
      padding: 20px 40px 30px;
      margin-top: 80px;
    }
    .tip-title{
      font-size: 30px;
      font-weight: bold;
    }
    .tip{
      line-height: 40px;
      font-size: 24px;
    }
  }
  .deposit-bottom{
    padding: 10px 55px;
    text-align: center;
    .cancel-btn{
      font-size: 30px;
      line-height: 42px;
      color: #999999;
      padding: 20px;
      margin-top: 10px;
    }
  }
}
</style>
